import Accordion from "@/components/ui/accordion/accordion";
import FormBtn from "@/components/ui/form-btn";
import SectionTitle from "@/components/ui/section-title";
import { useState } from "react";

const FAQ = ({ FAQ_Data }) => {

  const [visibleCount, setVisibleCount] = useState(3); // Show 3 FAQs initially
  const [showAll, setShowAll] = useState(false);

  const handleViewAll = () => {
    setShowAll(true);
    setVisibleCount(FAQ_Data.length); // Show all FAQs
  };

  const [num, setNum] = useState(-1);

  const accordionHandler = (i) => {
    if (i == num) {
      setNum(-1);
    } else {
      setNum(i);
    }
  };

  // Conditionally render the entire section if FAQ_Data is available
  if (!FAQ_Data || FAQ_Data.length === 0) {
    return null; // Return nothing if there's no data
  }

  return (
    <section className="container bg-[#F6F6F6] pt-5 pb-5 lg:pt-[2vw] lg:pb-[2.5vw]">
      
      <SectionTitle
        title={"FAQ's"}
        customClass={"mb-5 lg:mb-[2vw] text-center"}
      />

      {FAQ_Data.slice(0, visibleCount).map((item, i) => (
        <Accordion
          item={item}
          key={i}
          indexNum={i}
          num={num}
          clickHandler={accordionHandler}
          extraClasses={`border-b-[1px] border-[#939498] w-full relative md:text-center !text-[#000000]`}
        >
          {num === i && (
            <div className="p-4 lg:p-[1vw]">
              <div className="mb-3 lg:mb-[0.5vw] lg:leading-[1.9vw] text-[#58585A]">
                {item.answer}
              </div>
            </div>
          )}
        </Accordion>
      ))}

      {!showAll && FAQ_Data.length > visibleCount && (
        <FormBtn
          name={"View All"}
          customClass={"mx-auto mt-5 lg:mt-[2.5vw]"}
          onClick={handleViewAll}
        />
      )}
    </section>
  );
};

export default FAQ;
